import { __awaiter, __decorate, __extends, __generator } from "tslib";
import AbpBase from '@/lib/AbpBase';
import { Component, Prop } from 'vue-property-decorator';
import Treeselect, { LOAD_ROOT_OPTIONS } from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { OrganizationMapToTreeDtos, OrganizationTreeDtoMapToTreeNodes } from '@/store/modules/organization';
import { OrganizationUnitServiceProxy } from '@/lib/service-proxy/service-proxies';
import Template from './OrganizationSelect.html';
import { isArray } from 'util';
var OrganizationSelect = /** @class */ (function (_super) {
    __extends(OrganizationSelect, _super);
    function OrganizationSelect() {
        var _this = _super.call(this) || this;
        _this.data = null;
        _this.dataSource = [];
        _this.selectedData = [];
        _this.loading = false;
        _this.service = new OrganizationUnitServiceProxy();
        return _this;
    }
    OrganizationSelect.prototype.mounted = function () {
        // this.loadData();
    };
    OrganizationSelect.prototype.loadData = function () {
        var _this = this;
        return this.service.getOrganizationUnits(this.excludeTypes).then(function (result) {
            _this.dataSource = OrganizationMapToTreeDtos(result.items);
            return (_this.data = OrganizationTreeDtoMapToTreeNodes(_this.dataSource));
        });
    };
    OrganizationSelect.prototype.handleValueChanged = function (value) {
        if (value) {
            this.selectedData = this.dataSource.filter(function (item) {
                return isArray(value) ? value.includes(item.id) : item.id === value;
            });
        }
        else {
            this.selectedData = [];
        }
        this.$emit('input', value);
        this.$emit('on-change', this.selectedData);
    };
    OrganizationSelect.prototype.loadOptions = function (_a) {
        var action = _a.action, callback = _a.callback;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(action === LOAD_ROOT_OPTIONS)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.loadData()];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        Prop({ type: [Boolean], default: function () { return false; } })
    ], OrganizationSelect.prototype, "multiple", void 0);
    __decorate([
        Prop({ type: [Array], default: function () { return []; } })
    ], OrganizationSelect.prototype, "excludeTypes", void 0);
    __decorate([
        Prop({ default: function () { return []; } })
    ], OrganizationSelect.prototype, "value", void 0);
    OrganizationSelect = __decorate([
        Template,
        Component({
            components: {
                TreeSelect: Treeselect
            },
            filters: {}
        })
    ], OrganizationSelect);
    return OrganizationSelect;
}(AbpBase));
export default OrganizationSelect;
